module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "col-md-12"
  }, [_c('h2', {
    staticClass: "ff-medium title"
  }, [_vm._v(_vm._s(_vm.$t("dashboardModule.myOrdersTitle")))]), _vm._v(" "), _c('orderList')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9828b696","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/orders/Orders.vue
// module id = 3321
// module chunks = 0